import { render, staticRenderFns } from "./TimeDeltaHuman.vue?vue&type=template&id=c4c9d1c8&"
import script from "./TimeDeltaHuman.vue?vue&type=script&lang=ts&"
export * from "./TimeDeltaHuman.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports